export default {"src":"/_next/static/media/sunbed_24.f4be259b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};